import type { ReactNode } from "react";
import TherapistPhoto from "@/components/base/TherapistPhoto";

interface TeamPortraitStageProps {
  name: string;
  src?: string;
  children?: ReactNode;
  className?: string;
  variant: "card" | "profile" | "child";
}

/**
 * Context-based presentations for the standardized team portrait assets.
 * Inline sizing protects each stage ratio from flex-item shrinking and utility
 * ordering changes in generated CSS.
 */
export default function TeamPortraitStage({
  name,
  src,
  children,
  className = "",
  variant,
}: TeamPortraitStageProps) {
  const isCard = variant === "card";
  const isChild = variant === "child";

  return (
    <div
      className={`relative overflow-hidden ${isChild ? "bg-[#F8F5EE]" : "bg-white"} ${className}`}
      data-team-portrait-stage
      data-team-portrait-variant={variant}
      style={{
        width: "100%",
        height: "auto",
        aspectRatio: isCard ? "4 / 3" : "1 / 1",
        minHeight: 0,
        flexShrink: 0,
      }}
    >
      <TherapistPhoto
        src={src}
        name={name}
        className={`block h-full w-full ${isCard ? "object-cover object-top" : "object-contain object-bottom"}`}
      />
      {children}
    </div>
  );
}
